import { render, staticRenderFns } from "./createEditReseller.vue?vue&type=template&id=1b555af0&scoped=true&"
import script from "./createEditReseller.vue?vue&type=script&lang=js&"
export * from "./createEditReseller.vue?vue&type=script&lang=js&"
import style0 from "./createEditReseller.vue?vue&type=style&index=0&id=1b555af0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b555af0",
  null
  
)

export default component.exports